"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntegrationJobOutputLog = exports.IntegrationJobListEntry = void 0;
var react_1 = __importDefault(require("react"));
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var Integration_module_css_1 = __importDefault(require("../Integration.module.css"));
var FormattedDateTime = function (attrs) {
    if (attrs.dateTime) {
        var dt = attrs.dateTime instanceof Date ? attrs.dateTime : new Date(attrs.dateTime);
        return react_1.default.createElement("span", null, dt.getDate()
            + "/" + (dt.getMonth() + 1)
            + "-" + dt.getFullYear()
            + " " + ("0" + dt.getHours()).slice(-2)
            + ":" + ("0" + dt.getMinutes()).slice(-2)
            + ":" + ("0" + dt.getSeconds()).slice(-2));
    }
    return (react_1.default.createElement("span", null, "N/A"));
};
var IntegrationJobStatusIcon = function (attrs) {
    if (!attrs.job.ended_at) {
        return (react_1.default.createElement("span", { style: { marginRight: "4px" } },
            react_1.default.createElement(q_play_components_1.Spinner, null)));
    }
    else {
        if (attrs.job.exit_code === 0) {
            return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-check", style: { color: "var(--success-color)", marginRight: "5px" } }));
        }
        else {
            return (react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: "fa-xmark", style: { color: "var(--warning-color)", margin: "0 9px 0 2px" } }));
        }
    }
};
var IntegrationJobListEntry = function (props) {
    var style = { display: "flex", justifyContent: "flex-start" };
    if (props.onSelect) {
        style.cursor = "pointer";
    }
    return (react_1.default.createElement("div", { style: style, onClick: props.onSelect ? function () { return props.onSelect(props.job); } : undefined },
        react_1.default.createElement("div", null,
            react_1.default.createElement(IntegrationJobStatusIcon, { job: props.job })),
        react_1.default.createElement("div", null,
            react_1.default.createElement("div", null,
                react_1.default.createElement(FormattedDateTime, { dateTime: props.job.created_at })),
            react_1.default.createElement("small", null,
                "#",
                props.job.id,
                " ",
                props.job.resource))));
};
exports.IntegrationJobListEntry = IntegrationJobListEntry;
var IntegrationJobOutputLogEntryLine = function (attrs) {
    return (react_1.default.createElement("div", null,
        react_1.default.createElement("span", null, attrs.entry.timestamp.getDate()
            + "/" + (attrs.entry.timestamp.getMonth() + 1)
            + "-" + attrs.entry.timestamp.getFullYear()
            + " " + ("0" + attrs.entry.timestamp.getHours()).slice(-2)
            + ":" + ("0" + attrs.entry.timestamp.getMinutes()).slice(-2)
            + ":" + ("0" + attrs.entry.timestamp.getSeconds()).slice(-2)),
        ": ",
        react_1.default.createElement("span", null, attrs.entry.line)));
};
var IntegrationJobOutputLog = function (props) {
    var _a, _b;
    var logs = (_b = (_a = props.job) === null || _a === void 0 ? void 0 : _a.logs) === null || _b === void 0 ? void 0 : _b.filter(function (o) {
        return !o.silent;
    });
    return (react_1.default.createElement("div", { className: Integration_module_css_1.default["console-container"], style: { width: "100%", maxHeight: "35rem", overflowY: "auto" } }, logs && logs.length > 0
        ? logs.map(function (entry, key) { return (react_1.default.createElement(IntegrationJobOutputLogEntryLine, { key: key, entry: entry })); })
        : react_1.default.createElement(react_1.default.Fragment, null, "no logs")));
};
exports.IntegrationJobOutputLog = IntegrationJobOutputLog;
